<template>
  <sc-text
    class="c-home-icon-content__item"
    v-if="fields && fields.content"
    :field="fields.content"
  />
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Home-Icon-Content-Item',
  components: {
    ScText: Text
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.c-home-icon-content__item {
  position: relative;
  padding-left: 3.4rem;
  @include font-styles('Arial', 1.6rem, 300, normal, 2.2rem, 0, $white);

  @include tablet-up {
    width: 26.4rem;
    padding-left: 4.4rem;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 2.4rem;
    height: 2.4rem;
    // background: url(~@/assets/images/icon-checkmark-callout.svg) 50% no-repeat;
    -webkit-mask: url(~@/assets/images/icon-checkmark-callout.svg) 50% no-repeat;
    mask: url(~@/assets/images/icon-checkmark-callout.svg) 50% no-repeat;
    background-color: $lite-blue;
  }
}
</style>
